export default "<div id=\"contentOne\">\n  <mat-card>\n      <h1>{{titleOne}}</h1>\n      <p>{{contentOne}}</p>\n  </mat-card>\n</div>\n";